<script>
import NavBar from '@components/nav-bar.vue'
import Breadcrumb from '@components/breadcrumb.vue'
import Error from '@components/error.vue'
import Footer from '@components/footer.vue'

export default {
  components: { NavBar, Breadcrumb, Error, Footer },
  props: {
    breadcrumb: {
      type: Array,
    },
    lastUpdated: {
      type: Array,
    },
    error: {
      type: String,
    },
  },
  methods: {},
}
</script>

<template>
  <div class="layout layout-nav-side">
    <NavBar />

    <div class="main-container">
      <Breadcrumb />

      <slot v-if="!error" />
      <div v-if="error" class>
        <Error :error="error" />
      </div>

      <Footer :last-updated="lastUpdated" />
    </div>
  </div>
</template>
